<template>
  <base-dropdown>
    <template #title>
      <button
        class="btn btn-info dropdown-toggle btn-block"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="!disabled ? false : true"
      >
        <i class="fa fa-print"></i> In
      </button>
    </template>
    <a
      class="dropdown-item"
      :class="{ disabled: countChecked == 0 }"
      href="#"
      @click="$emit('print')"
    >
      <i class="fa fa-check text-primary"></i>
      In dòng đã chọn ({{ countChecked }})
    </a>
    <a class="dropdown-item" href="#" @click="$emit('printAll')">
      <i class="fa fa-check-double text-info"></i>
      In Tất cả
    </a>
  </base-dropdown>
</template>

<script>
export default {
  name: "print-button",
  props: {
    disabled: {},
    countChecked: {
      type: Number,
      required: true
    }
  }
};
</script>

<style></style>
